module.exports = __webpack_public_path__ + "static/media/ic_quantou.fda381bc.svg";